import { render } from "./LoginComponent.vue?vue&type=template&id=00348230&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=00348230&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00348230"],['__file',"src/views/h5/common/login/component/LoginComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00348230"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00348230', __exports__)) {
    api.reload('00348230', __exports__)
  }
  
  module.hot.accept("./LoginComponent.vue?vue&type=template&id=00348230&scoped=true", () => {
    api.rerender('00348230', render)
  })

}


export default __exports__